import React from 'react';

import BookmarkIcon from 'Assets/icons/bookmark.svg';
import XmarkIcon from 'Assets/icons/xmark.svg';

/**
 * Always-visible panel of the user's saved views. Each chip applies its view on
 * click; the × removes it. Updates live as views are added/removed.
 *
 * @ticket IB-644
 */
export default function SavedViews({ views, activeId, onApply, onDelete }) {
    if (!views || views.length === 0) {
        return null;
    }

    return (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-mt-4">
            <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-[13px] tw-text-charcoal-75 tw-font-medium">
                <BookmarkIcon className="tw-h-3.5 tw-w-3.5" aria-hidden="true" />
                {$t('Saved views')}:
            </span>

            {views.map((saved) => {
                const active = saved.id === activeId;
                return (
                    <span
                        key={saved.id}
                        className={[
                            'tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-border tw-pl-3 tw-pr-1.5 tw-py-1 tw-text-[12.5px]',
                            active ? 'tw-bg-blue tw-text-white tw-border-blue' : 'tw-bg-white tw-text-charcoal-75 tw-border-charcoal-50',
                        ].join(' ')}
                    >
                        <button type="button" onClick={() => onApply(saved)} className="tw-max-w-[16rem] tw-truncate tw-text-left" title={saved.name}>
                            {saved.name}
                        </button>
                        <button
                            type="button"
                            onClick={() => onDelete(saved.id)}
                            aria-label={$t('Delete view')}
                            title={$t('Delete view')}
                            className={[
                                'tw-inline-flex tw-items-center tw-justify-center tw-h-4 tw-w-4 tw-rounded-full tw-shrink-0',
                                active ? 'hover:tw-bg-white/20' : 'tw-text-charcoal-50 hover:tw-bg-charcoal-10',
                            ].join(' ')}
                        >
                            <XmarkIcon className="tw-h-3 tw-w-3" aria-hidden="true" />
                        </button>
                    </span>
                );
            })}
        </div>
    );
}
